import PropTypes from 'prop-types';
import React from 'react';

const Logo = ({ size = 'default' }) => {
  // El API no da un nombre de marca visible (tenant.name es un identificador interno): no hay nada fiable que anunciar.
  return <div aria-hidden="true" className={`logo logo--${size}`} />;
};

Logo.propTypes = {
  size: PropTypes.oneOf(['small', 'default', 'big']),
};

export default Logo;
